import { useEffect, useState } from "react";
import { Table, Skeleton, Col, Row, Space, Button } from "antd";
import DateTimeStamp from "../misc/DateTimeStamp";
import "./PrintHistoryPage.scss";
import "./PrintOrderDetailPage.scss";
import OrdersApi from "../../../api/OrdersApi";
import { OrderDto, ProductDto } from "../../../generated/print-client";
import { useParams } from "react-router-dom";
import { Currency } from "../../util/Currency";
import { env } from "../../../env/env";
import { getFriendlyOrderStatus, getPaginationTitle, getPrintCartSizeLabel, prettifyPaperSize, removeDash } from "../../../util/utils";
import {useRecoilValue} from "recoil";
import {mobileState} from "../../../state/atoms";
import { PrintOrderPrintableReceipt } from "./PrintOrderPrintableReceipt";
// import { env } from "process";

export function PrintOrderDetailPage() {
  const { id } = useParams();
  const [order, setOrder] = useState({} as OrderDto);
  const [loading, setLoading] = useState(true);
  const mobile = useRecoilValue(mobileState);

  useEffect(() => {
    if (id) {
      setLoading(true);
      OrdersApi.get(id).then((resp) => {
        setOrder(resp.data);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  }, [id]);

  function printReceipt() {
    var printable = document.getElementById("printable-receipt")!.innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printable;
    window.print();
    document.body.innerHTML = originalContents;
    
    window.location.reload()

    // var printWindow = window.open('', '', '')!;
    // printWindow.document.write(printable);
    // printWindow.document.close();
    // printWindow.print();
  }

  return (
    <div className={"print-order-detail-page content"}>

      <div id="printable-receipt" style={{ display: "none" }}>
        {/* <div id="printable-receipt"> */}
        <PrintOrderPrintableReceipt order={order} />
      </div>

      {loading && <Skeleton />}

      {!loading && (
        <>
          <Row>
            <Col span={10}>
              <h3>Order #{order.number}</h3>

              <Row>
                <Col>
                  <b>Status:</b> {getFriendlyOrderStatus(order.status!)}
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>Date Placed:</b> <DateTimeStamp date={order.purchaseDate!} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>Total:</b> ${order.total?.toFixed(2)}
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>Payment Method:</b> {order.maskedCard}
                </Col>
              </Row>
              {/* {order.receiptUrl ? */}
              <Row>
                <Button size="large" className={"receipt-btn"} onClick={printReceipt}>
                  Print Receipt
                </Button>
              </Row>
              {/* } */}
            </Col>

            <Col span={10}>
              <Space>
                <h3>Delivery Address</h3>
              </Space>

              <Row>
                <Col><b>Address Type:</b> <span className="cap">{order.addressType}</span></Col>
              </Row>
              <Row>
                <Col>{order.name}</Col>
              </Row>
              <Row>
                <Col>{order.businessName}</Col>
              </Row>
              <Row>
                <Col>{order.addressLine1}</Col>
              </Row>
              <Row>
                <Col>{order.addressLine2}</Col>
              </Row>
              <Row>
                <Col>{order.city}, {order.state}, {order.zip}</Col>
              </Row>
              <Row>
                <Col>{order.phone}</Col>
              </Row>
              <Row>
                <Col>Expected delivery date: {order.edd}</Col>
              </Row>
              <br />
              <Row>
                <Col><b>Shipping Method:</b> Standard Shipping and Processing</Col>
              </Row>
              {order.tracking ?
                <Row>
                  <Col><b>Tracking:</b> <a href={"http://wwwapps.ups.com/WebTracking/processInputRequest?tracknum=" + order.tracking} target="_blank" rel="noreferrer">{order.tracking}</a></Col>
                </Row>
                : ''}
            </Col>
          </Row>

          <h3 className="summary-header">Order Summary</h3>
          {!mobile &&
            <Table
              loading={loading}
              pagination={false}
              columns={[
                {
                  title: "Design Name",
                  dataIndex: "designId",
                  key: "designId",
                  render: (designId, item) => (
                    <img
                      alt={item.designName}
                      src={item.thumbs ? env.s3Path + '/' + JSON.parse(item.thumbs)[0].path : `${env.rendererPath}/design/thumbnail/${designId}?height=150`}
                    />
                  )
                },
                {
                  title: "",
                  dataIndex: "designName",
                  key: "designName",
                  render: (designName) => (
                    <>
                      {designName}
                    </>
                  ),
                },
                {
                  title: "Products",
                  dataIndex: "products",
                  key: "product",
                  render: (products) => (
                    <>
                      {products.map((product: ProductDto) => {
                        return <>{product.name}<br /></>
                      })}
                    </>
                  ),
                },
                {
                  title: "Pages",
                  dataIndex: "pages",
                  key: "pages",
                  align: "center"
                },
                {
                  title: "Paper Type",
                  dataIndex: "paperType",
                  key: "paperType",
                  align: "center",
                  width: 120,
                  render: (paperType) => (
                    <span className="cap">{removeDash(paperType)}</span>
                  )
                },
                {
                  title: "Quantity",
                  dataIndex: "quantity",
                  key: "quantity",
                  align: "center"
                },
                {
                  title: "Price",
                  dataIndex: "price",
                  key: "price",
                  align: "center",
                  render: (price) => (
                    <Currency>{price}</Currency>
                  ),
                },
              ]}
              dataSource={order.items}
            />}


          {mobile &&
            <div className="mobile-summary">
              {order.items?.map((item: any) => (
                <div className={`item`}>
                  <div className="thumb">
                    <img alt={item.designName} src={`${env.rendererPath}/design/thumbnail/${item.designId}?height=200`} />
                  </div>

                  <div className="info">
                    <div className="name">{item.designName}</div>
                    <div>{prettifyPaperSize(item.paperSize)} {getPrintCartSizeLabel(item.designSize)} - {item.pages} {item.pages === 1 ? 'page' : 'pages'}</div>
                    <div className="cap">{removeDash(item.paperType)}</div>
                    <div>{getPaginationTitle(item.pagination)}</div>
                    <div>{item.quantity} Copies</div>
                    <div className="price">${item.price.toFixed(2)}</div>
                    {item.designSize.indexOf('gift-certificate') > -1 && <span>Starting Number {item.gcStartingNumber}</span>}
                  </div>
                </div>
              ))}
            </div>}

          <Row className="totals">
            <Col span={7} push={17}>
              <Row justify="space-between">
                <Col>Subtotal:</Col>
                <Col><Currency>{order.subtotal}</Currency></Col>
              </Row>

              <Row justify="space-between">
                <Col>Shipping &amp; Processing:</Col>
                <Col><Currency>{order.shipping}</Currency></Col>
              </Row>

              <Row justify="space-between">
                <Col>Tax:</Col>
                <Col><Currency>{order.tax}</Currency></Col>
              </Row>

              <Row justify="space-between" className="total">
                <Col>Total:</Col>
                <Col><Currency>{order.total}</Currency></Col>
              </Row>
            </Col>
          </Row>


        </>
      )}
    </div>
  );
}
